import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'

import Button from 'components/buttons/Button/Button'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import Modal from 'components/modal/Modal/Modal'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'

import s from './DialogModal.scss'


class DialogModal extends Component {

  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      onClose: PropTypes.func,
      isButtonLoading: PropTypes.bool,
      showCloseButton: PropTypes.bool,
      disableClose: PropTypes.bool,
      disableCloseOverlay: PropTypes.bool,
    }),
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    titleUppercase: PropTypes.bool,
    buttonTitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    subText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    isWhiteButton: PropTypes.bool,
  }

  close = () => {
    const { name, data } = this.props

    actions.models.modals.close(name)

    if (data && typeof data.onClose === 'function') {
      data.onClose()
    }
  }

  render() {
    const { name, title, titleUppercase, subText, buttonTitle, data, children, isWhiteButton, className } = this.props

    const buttonProps = {
      className: s.button,
      whiteWithBorder: isWhiteButton,
      brand: !isWhiteButton,
      loading: data && data.isButtonLoading,
      onClick: this.close,
      dataTestId: constants.testIds.modal.dialogModal.button,
      'data-s-click-toggle-off': name, // prop for landings!!!
      ...(buttonTitle ? {
        title: buttonTitle,
      } : {
        finish: true,
      }),
    }

    const buttonNode = React.createElement(buttonTitle ? Button : CommonButton, buttonProps)

    return (
      <Modal
        name={name}
        title={title}
        titleUppercase={titleUppercase}
        subText={subText}
        data={data}
        className={className}
      >
        <Fragment>
          {children}
          <ModalFooter>
            {buttonNode}
          </ModalFooter>
        </Fragment>
      </Modal>
    )
  }
}


export default DialogModal
